export const ZLE_HASLO_DO_CERTYFIKATU = 'ZLE_HASLO_DO_CERTYFIKATU'
export const BLAD_WALIDACJI_USLUGI_ZUS = 'BLAD_WALIDACJI_USLUGI_ZUS'
export const BRAK_PLATNIKA = 'BRAK_PLATNIKA'
